import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./quasar";
import i18n from "./i18n";
import "@/scss/custom.scss";
import VueGtag from "vue-gtag";
// Vue.use(VueGtag, {
//   config: { id: "G-7B1XMCTZ0F" }
// }, router);
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_ANALYTICS_ID },
    pageTrackerTemplate(to) {
      let title = to.name;
      if (title == "Home") {
        title = "SMAPA";
      }
      if (title == "Telefonos") {
        title = "Oficinas y Teléfonos - SMAPA";
      }
      if (title == "Tramites") {
        title = "Trámites y pagos online - SMAPA";
      }
      if (title == "Galerias") {
        title = "Galerías - SMAPA";
      }
      if (title == "DetalleGaleria") {
        title = "Galeria";
      }
      if (title == "Noticias") {
        title = "Noticias - SMAPA";
      }
      if (title == "Publicacion") {
        title = "SMAPA";
      }
      if (title == "PublicacionPreview") {
        title = "Noticia Preview";
      }
      if (title == "Categoria") {
        title = "Noticias";
      }
      if (title == "Comuna") {
        title = "Comuna";
      }
      if (title == "Municipalidad") {
        title = "SMAPA";
      }
      if (title == "Destacado") {
        title = "Destacado";
      }
      if (title == "Pagina") {
        title = "SMAPA";
      }
      if (title == "PaginaPreview") {
        title = "Preview Página";
      }
      if (title == "Contacto") {
        title = "Formulario de Consultas - SMAPA";
      }
      if (title == "Concejo") {
        title = "Concejo Municipal - SMAPA";
      }
      if (title == "Cam") {
        title = "Centros de Atención Municipal - SMAPA";
      }
      if (title == "Organizaciones") {
        title = "Ley 21.146 - SMAPA";
      }
      if (title == "OfertasOmil") {
        title = "Ofertas Laborales OMIL - SMAPA";
      }
      if (to.params.nombre) {
        if (title == "SMAPA") {
          title = to.params.nombre.replaceAll("-", " ") + " - " + title;
        } else {
          title = title + " - " + to.params.nombre.replaceAll("-", " ");
        }
      }
      return {
        page_title: title,
        page_path: to.path
      };
    }
  },
  router
);

//Truncate text
var filter = function (text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  if (content) {
    return content.length > length ? content.slice(0, length) + clamp : content;
  } else {
    return text;
  }
};
Vue.filter("truncate", filter);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
